import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './setDescription.view.html';
let SetDescriptionComponent = class SetDescriptionComponent {
    constructor() {
        this.onDescriptionChange = (event) => {
            const description = event.detail.value;
            this.onDescriptionChanges({ description });
        };
        this.actionBlur = () => {
            this.onActionBlur(this.action);
        };
    }
    //#endregion
    $onInit() {
        if (!this.action.$description) {
            this.action.$description = '';
        }
    }
    openSchemaEditor() {
        this.onOpenSchemaEditor(this.action);
    }
};
SetDescriptionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: template,
        bindings: {
            action: '=',
            onDescriptionChanges: '&',
            onOpenSchemaEditor: '&',
            onActionBlur: '&',
        },
    })
], SetDescriptionComponent);
export { SetDescriptionComponent };
